import { FormStore } from './form.store';

class AppStore {
  public formStore = new FormStore();
}

export { AppStore };
